import { render, staticRenderFns } from "./PreviewSVG.vue?vue&type=template&id=487f0f92&scoped=true&"
import script from "./PreviewSVG.vue?vue&type=script&lang=js&"
export * from "./PreviewSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f0f92",
  null
  
)

export default component.exports